module.exports = __webpack_public_path__ + "static/media/moons_calificaciones_opiniones.20fcaab5.svg";